import React, { useMemo, lazy, Suspense } from "react";
import { FLOW_TYPES } from "../constants/flowType";
import { useTicketingContext } from "../store";
import AppLayout from "./../layouts/AppLayout";
import { LoaderSpinner } from "../components/LoaderSpinner";

const Tickets = lazy(() => import("./Tickets"));
const DateTime = lazy(() => import("./DateTime"));
const CopenhagenCard = lazy(() => import("./CopenhagenCard"));
const Activities = lazy(() => import("./Activities"));
const GiftCard = lazy(() => import("./GiftCard"));
const ActivitiesOnly = lazy(() =>
  import("./Activities").then((m) => ({ default: m.ActivitiesOnly }))
);

const Routes = () => {
  const { state } = useTicketingContext();

  const isAdmission = state.flowType === FLOW_TYPES.ADMISSION;
  const activeStep = isAdmission ? (state.stepper?.active ?? 0) : 2;

  const content = useMemo(() => {
    if (state.is_gift_card) {
      return <GiftCard />;
    }
    switch (activeStep) {
      case 0:
        return state.is_city_card ? <CopenhagenCard /> : <Tickets />;
      case 1:
        return <DateTime />;
      case 2:
        return isAdmission ? <Activities /> : <ActivitiesOnly />;
      default:
        return <Tickets />;
    }
  }, [activeStep, isAdmission, state.is_city_card, state.is_gift_card]);

  return (
    <AppLayout>
      <Suspense fallback={<LoaderSpinner />}>{content}</Suspense>
    </AppLayout>
  );
};

export default React.memo(Routes);
